import PreviousInvites from './PreviousInvites';

export default PreviousInvites;